// extracted by mini-css-extract-plugin
export default {"containerAll":"reportUsers_containerAll__F97wb","reporterDiv":"reportUsers_reporterDiv__baZ9p","detailContainer":"reportUsers_detailContainer__Hsv0J"};